function insertarCalculadoraEnHeader() {
    const linkOriginal = document.querySelector('a[href="/pages/protein-calculator-savvy"]');
    const contenedor = document.querySelector(".t4s-site-nav__icons");

  
    if (linkOriginal && contenedor && !contenedor.querySelector('a[href="/pages/protein-calculator-savvy"]')) {
      const nuevoLink = linkOriginal.cloneNode(true);
      nuevoLink.classList.add("t4s-icon", "t4s-icon--custom");
      contenedor.insertBefore(nuevoLink, contenedor.firstChild);
    }
    
  }
  
  // Ejecutar cuando cargue por primera vez
  document.addEventListener("DOMContentLoaded", () => {
    insertarCalculadoraEnHeader();
  
    // Observar cambios en el header
    const header = document.querySelector("header");
    if (header) {
      const observer = new MutationObserver(() => {
        insertarCalculadoraEnHeader();
      });
  
      observer.observe(header, {
        childList: true,
        subtree: true,
      });
    }
  });
  